import IssueTypes from "../../../views/IssueType";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import IssueTypesAction from "../../../views/IssueTypeAction";

const LogisticsSupportRoutes = [
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
    path: "/issue-types",
    component: IssueTypes,
    exact: true,
  },
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
    path: "/issue-types/create",
    component: IssueTypesAction,
    exact: true,
  },
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
    path: "/issue-types/:id/:action",
    component: IssueTypesAction,
    exact: true,
  },
];

export default LogisticsSupportRoutes;